import { useGetAssessmentProgresses } from "@/api/console/assessment-progresses/useGetAssessmentProgresses";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { InputWithIcon } from "@/components/ui/input";
import { STATUS } from "@/config/progress";
import { BuildingRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ReAssessmentTable from "./_components/ReAssessmentTable";

function ReAssessments() {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: t("re-assessments"),
      href: "/console/re-assessments",
    },
  ];

  const [search, setSearch] = useState("");

  const statues = [
    STATUS.ASSESSMENT_COMPLETED,
    STATUS.RE_ASSESSMENT,
    STATUS.RE_ASSESSMENT_GRADED_COMPLETED,
    STATUS.RE_ASSESSMENT_EVALUATION_COMPLETED,
  ];

  const { data, isLoading } = useGetAssessmentProgresses(statues.join(","));
  const reAssessments = data?.data ?? [];

  const searchedReAssessments = reAssessments.filter((reAssessment) =>
    (reAssessment.company_name ?? "")
      .toLowerCase()
      .includes(search.toLowerCase()),
  );

  return (
    <div className="grow">
      <div className="bg-white shadow">
        <AdminNavbar breadcrumbs={breadcrumbs} />
        <div className="my-heading px-6 pt-8">{t("re-assessments")}</div>
        <div className="flex justify-between px-6 pb-6 pt-8">
          <InputWithIcon
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            Icon={BuildingRegular}
            placeholder="Search"
          />
        </div>
      </div>
      <div className="mx-6 mt-6">
        <ReAssessmentTable data={searchedReAssessments} isLoading={isLoading} />
      </div>
    </div>
  );
}

export default ReAssessments;
